import {Permissions} from '@/core/config/enums/Permissions'
import { Paths } from '@/core/config/enums/SitePaths';
const DocMenuConfig = [
  {
    heading: "Core",
    pages: [
      {
        heading: "Dashboard",
        route: Paths.DASHBOARD,
        svgIcon: "/media/icons/duotune/ecommerce/ecm001.svg",
        fontIcon: "bi-grid",
      },
      {
        heading: "Dashboard V2",
        route: Paths.DASHBOARD_V2,
        svgIcon: "/media/icons/duotune/ecommerce/ecm001.svg",
        fontIcon: "bi-speedometer2",
      },
      {
        heading: "Monitoring",
        route: Paths.MONITORING,
        svgIcon: "/media/icons/duotune/ecommerce/ecm001.svg",
        fontIcon: "bi-activity",
      },
      {
        heading: "Goal Timing",
        route: Paths.GOAL_TIMING,
        svgIcon: "/media/icons/duotune/ecommerce/ecm001.svg",
        fontIcon: "bi-stopwatch",
      },
      {
        heading: "Home Highlights",
        route: "/home-highlights/edit/1",
        svgIcon: "/media/icons/duotune/ecommerce/ecm001.svg",
        fontIcon: "bi-star",
      },
      {
        heading: "Home Highlights V2",
        route: "/home-highlights-v2/edit/1",
        svgIcon: "/media/icons/duotune/ecommerce/ecm001.svg",
        fontIcon: "bi-star",
      },
      {
        heading: "Players of Period",
        route: "/players-of-period/edit/1",
        svgIcon: "/media/icons/duotune/ecommerce/ecm001.svg",
        fontIcon: "bi-people",
      },
      {
        heading: "General Settings",
        route: "/generalSettings/edit/2",
        svgIcon: "/media/icons/duotune/ecommerce/ecm001.svg",
        fontIcon: "bi-gear",
      },
    ],
  },
  {
    heading: "Content & Engagement",
    pages: [
      {
        heading: "Missions",
        route: Paths.MISSIONS,
        svgIcon: "/media/icons/duotune/ecommerce/ecm001.svg",
        fontIcon: "bi-trophy",
      },
      {
        heading: "Send Notification",
        route: "/notifications/add",
        svgIcon: "/media/icons/duotune/ecommerce/ecm001.svg",
        fontIcon: "bi-bell",
      },
      {
        heading: "FAQ",
        route: Paths.FAQ,
        svgIcon: "/media/icons/duotune/ecommerce/ecm001.svg",
        fontIcon: "bi-question-circle",
      },
      {
        heading: "Contact Form Requests",
        route: Paths.CONTACT_FORM_REQUESTS,
        svgIcon: "/media/icons/duotune/ecommerce/ecm001.svg",
        fontIcon: "bi-envelope",
      },
      {
        heading: "Report Issue Requests",
        route: Paths.REPORT_ISSUE_REQUESTS,
        svgIcon: "/media/icons/duotune/ecommerce/ecm001.svg",
        fontIcon: "bi-flag",
      },
      {
        heading: "Text Constants",
        route: Paths.TEXT_CONSTANTS,
        svgIcon: "/media/icons/duotune/ecommerce/ecm001.svg",
        fontIcon: "bi-fonts",
      },
    ],
  },
  {
    heading: "Sports Catalog",
    pages: [
      {
        heading: "Games",
        route: Paths.GAMES,
        svgIcon: "/media/icons/duotune/ecommerce/ecm001.svg",
        fontIcon: "bi-controller",
      },

      {
        heading: "Leagues Order",
        route: Paths.LEAGUES_ORDER_PAGE,
        svgIcon: "/media/icons/duotune/ecommerce/ecm001.svg",
        fontIcon: "bi-sort-numeric-down",
      },

     {
        heading: "Betting Companies",
        route: Paths.BETTING_COMPANIES,
        svgIcon: "/media/icons/duotune/ecommerce/ecm001.svg",
        fontIcon: "bi-building",
      },
      {
        heading: "Markets",
        route: Paths.MARKETS,
        svgIcon: "/media/icons/duotune/ecommerce/ecm001.svg",
        fontIcon: "bi-shop",
      },
      {
        heading: "Countries",
        route: Paths.COUNTRIES,
        svgIcon: "/media/icons/duotune/ecommerce/ecm001.svg",
        fontIcon: "bi-globe",
      },
       {
        heading: "Teams",
        route: Paths.TEAMS,
        svgIcon: "/media/icons/duotune/ecommerce/ecm001.svg",
        fontIcon: "bi-people",
      },
      {
        heading: "Leagues",
        route: Paths.LEAGUES,
        svgIcon: "/media/icons/duotune/ecommerce/ecm001.svg",
        fontIcon: "bi-list-ol",
      },
      {
        heading: "Tournaments",
        route: Paths.TOURNAMENTS,
        svgIcon: "/media/icons/duotune/ecommerce/ecm001.svg",
        fontIcon: "bi-layers",
      },
      {
        heading: "Tournament Points",
        route: Paths.TOURNAMENT_POINTS,
        svgIcon: "/media/icons/duotune/ecommerce/ecm001.svg",
        fontIcon: "bi-trophy",
      },
      {
        heading: "Sponsors",
        route: Paths.SPONSORS,
        svgIcon: "/media/icons/duotune/ecommerce/ecm001.svg",
        fontIcon: "bi-bookmark-star",
      },

    ],
  },

  {
    heading: "Commerce & Economy",
    pages: [
      {
        heading: "Coins Transactions",
        route: Paths.TRANSACTIONS,
        svgIcon: "/media/icons/duotune/ecommerce/ecm001.svg",
        fontIcon: "bi-coin",
      },
      {
        heading: "Points",
        route: Paths.POINTS,
        svgIcon: "/media/icons/duotune/ecommerce/ecm001.svg",
        fontIcon: "bi-award",
      },

      {
        heading: "Purchases",
        route: Paths.PURCHASES,
        svgIcon: "/media/icons/duotune/ecommerce/ecm001.svg",
        fontIcon: "bi-cart",
      },
      {
        heading: "Coupons",
        route: Paths.COUPONS + '?Status=0&Status_text=Open',
        svgIcon: "/media/icons/duotune/ecommerce/ecm001.svg",
        fontIcon: "bi-ticket-perforated",
      },
      {
        heading: "Expired Coupons",
        route: Paths.COUPONS_EXPIRED,
        svgIcon: "/media/icons/duotune/ecommerce/ecm001.svg",
        fontIcon: "bi-clock-history",
      },
    ],
  },
  {
    heading: "Users & Access",
    pages: [
      {
        heading: "Users",
        route: Paths.USERS,
        svgIcon: "/media/icons/duotune/finance/fin006.svg",
        fontIcon: "bi-person",
        permission: Permissions.USERS_PERMISSIONS,
      },
    ],
  },

];

export default DocMenuConfig;
